var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197.28mm",
    height: "117.27mm",
    viewBox: "0 0 197.28 117.27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1393"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5259e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5259e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1413"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1437"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m358.5 296.25h111v110.25h-111z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1477"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m324 171h125.25v125.25h-125.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1487"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1509"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m261 59.25h229.5v173.25h-229.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1519"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1569"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m448.5 179.25h154.5v154.5h-154.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1579"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.404 -46.513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -51.726 191.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.943 78.792h559.22v332.41h-559.22z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.63 177.75c0 27.96 22.49 50.62 50.25 50.62 27.75 0 50.25-22.66 50.25-50.62s-22.5-50.63-50.25-50.63c-27.76 0-50.25 22.67-50.25 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.63 177.75c0 27.96 22.49 50.62 50.25 50.62 27.75 0 50.25-22.66 50.25-50.62s-22.5-50.63-50.25-50.63c-27.76 0-50.25 22.67-50.25 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.38 105.37h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.38 105.37h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.13 105.37h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.13 105.37h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.63 192.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.63 192.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.38 194.62c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.38 194.62c0 9.12 7.55 16.5 16.87 16.5s16.88-7.38 16.88-16.5c0-9.11-7.56-16.5-16.88-16.5s-16.87 7.39-16.87 16.5z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m209.33 186.35c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.94-0.88 1.94-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.27 186.55c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.94 1.95 1.94s1.95-0.87 1.95-1.94z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.38 222.37 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m189.38 222.37 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.75 162.48-9.04-10.88c-4.99-6.01-12-8.42-15.65-5.39-3.65 3.04-2.57 10.37 2.42 16.37l9.04 10.88z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.75 162.48-9.04-10.88c-4.99-6.01-12-8.42-15.65-5.39-3.65 3.04-2.57 10.37 2.42 16.37l9.04 10.88z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m254.85 177.91 11.89 7.66c6.56 4.23 13.97 4.43 16.54 0.44s-0.66-10.66-7.23-14.89l-11.88-7.66z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m254.85 177.91 11.89 7.66c6.56 4.23 13.97 4.43 16.54 0.44s-0.66-10.66-7.23-14.89l-11.88-7.66z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m253.88 165.75c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.88 165.75c0-5.59-7.22-10.13-16.13-10.13s-16.12 4.54-16.12 10.13h5.06c0-2.8 4.95-5.06 11.06-5.06s11.06 2.26 11.06 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1437)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5417,-3.77e-7,-3.77e-7,1.5312,358.5,296.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1447)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.372 60.148h-7.403l-6.64 5.393c-1.254 1.017-2.818 1.573-4.431 1.575h-8.685c-2.52-3e-3 -4.847-1.353-6.1-3.541l-4.125-7.21-1.854-0.349c-1.981-0.373-3.769-1.429-5.051-2.984l-6.5253-7.922c-1.7277-2.103-2.6727-4.74-2.6737-7.462v-3.75c0.0022-2.709 0.9392-5.334 2.6527-7.432l1.9928-2.436v-3.459c0.0082-7.618 6.1815-13.792 13.8-13.8h20.244c2.687 0.0058 4.961 1.9854 5.336 4.645h6.172c5.364 9e-3 9.973 3.809 11.003 9.072l1.112 5.73c0.235 1.211 0.354 2.442 0.354 3.675v21.075c-6e-3 5.067-4.112 9.173-9.178 9.18zm7.68-30.253c-1e-3 -1.138-0.11-2.273-0.326-3.39l-1.113-5.73c-0.892-4.56-4.885-7.852-9.532-7.859h-10.733c-0.414 0-0.75-0.335-0.75-0.75 0-0.414 0.336-0.75 0.75-0.75h3.045c-0.36-1.8249-1.959-3.1419-3.82-3.145h-20.244c-6.79 0.0074-12.292 5.51-12.3 12.3v1.624l0.993-1.212c0.257-0.326 0.728-0.382 1.054-0.126 0.325 0.256 0.381 0.728 0.125 1.053-6e-3 8e-3 -0.012 0.016-0.018 0.023l-4.486 5.482c-1.4939 1.83-2.3109 4.119-2.313 6.481v3.75c0.0019 2.374 0.8268 4.673 2.334 6.506l6.525 7.922c1.058 1.284 2.534 2.156 4.169 2.463l9.589 1.8c0.409 0.064 0.689 0.448 0.624 0.858-0.064 0.409-0.448 0.688-0.857 0.624-0.015-2e-3 -0.029-5e-3 -0.043-8e-3l-5.799-1.087 3.49 6.106c0.985 1.721 2.815 2.783 4.797 2.786h8.685c1.269-1e-3 2.499-0.438 3.485-1.238l10.658-8.662c0.317-0.267 0.79-0.228 1.057 0.089 0.268 0.316 0.228 0.789-0.088 1.057-9e-3 7e-3 -0.017 0.014-0.026 0.02l-2.175 1.766h5.557c4.239-5e-3 7.675-3.441 7.68-7.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.726 43.024c3e-3 0.252 0.034 0.504 0.093 0.75h-4.523v-1.5h4.523c-0.059 0.245-0.09 0.497-0.093 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.297 45.836-3.2 3.2-1.063-1.061 3.199-3.199c0.269 0.43 0.633 0.793 1.064 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.799 46.254v4.522h-1.5v-4.522c0.492 0.123 1.008 0.123 1.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.861 44.776 3.201 3.199-1.061 1.061-3.2-3.2c0.43-0.268 0.793-0.63 1.06-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.799 39.793c-0.492-0.123-1.008-0.123-1.5 0v-4.522h1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.371 43.024c-1e-3 -0.253-0.032-0.505-0.092-0.75h4.523v1.5h-4.523c0.06-0.246 0.091-0.498 0.092-0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.236 41.272-3.202-3.201 1.06-1.06 3.2 3.2c-0.429 0.268-0.791 0.631-1.058 1.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.801 40.211 3.2-3.2 1.061 1.06-3.201 3.201c-0.267-0.43-0.63-0.793-1.06-1.061z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.888 31.769c-0.341 0.236-0.808 0.151-1.044-0.19s-0.151-0.808 0.19-1.044l0.925-0.639-2.194-1.598c-0.253 0.043-0.511 0.043-0.764 0-2.905-0.41-5.857-0.368-8.751 0.125-2.376 0.343-3.711-1.071-3.979-2.625-0.112-0.687-0.022-1.393 0.259-2.031l-3.603-4.501c-0.259-0.323-0.207-0.796 0.117-1.055 0.323-0.258 0.795-0.206 1.054 0.117l3.368 4.212c0.377-0.3 0.82-0.506 1.293-0.6 1.879-0.361 3.787-0.548 5.7-0.56 1.535-0.086 3.07 0.175 4.491 0.764 0.03-0.06 0.067-0.116 0.112-0.165l3.056-2.973c0.3-0.285 0.774-0.274 1.06 0.026 0.282 0.296 0.275 0.762-0.015 1.05l-3.055 2.972c-0.045 0.038-0.096 0.07-0.15 0.095 0.628 1.036 1.431 2.937 0.987 4.155l2.324 1.689 1.357-0.936c0.339-0.237 0.807-0.155 1.044 0.185 0.238 0.339 0.156 0.807-0.184 1.044-3e-3 2e-3 -5e-3 4e-3 -8e-3 6e-3zm-12.833-8.359c-0.947 0.234-1.529 1.187-1.304 2.136 0.128 0.879 0.918 1.506 1.803 1.432 0.162 0 0.324-0.013 0.484-0.037 3.041-0.514 6.143-0.556 9.196-0.123 0.099 0.023 0.201 0.023 0.3 0 0.235-0.286-0.189-1.988-1.022-3.16-0.608-0.847-5.086-1.128-9.457-0.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.733 33.658c0.079-0.339 0.382-0.578 0.73-0.579 0.058 0 0.115 7e-3 0.171 0.021 0.403 0.094 0.654 0.497 0.56 0.9l-3.62 15.427c-0.091 0.404-0.492 0.658-0.897 0.567-0.404-0.091-0.658-0.492-0.567-0.896 1e-3 -5e-3 2e-3 -9e-3 3e-3 -0.014l1.785-7.607c-0.207 0.111-0.456 0.115-0.667 0.011l-7.715-3.879 0.261 4.981c1.283 0.397 2.001 1.759 1.605 3.042-0.397 1.283-1.759 2.001-3.042 1.604s-2.001-1.759-1.604-3.042c0.23-0.744 0.803-1.333 1.541-1.584l-0.276-5.284-5.933 4.109c-0.34 0.236-0.808 0.151-1.043-0.189-0.236-0.341-0.152-0.808 0.189-1.044l6.694-4.636-0.184-3.518-4.988-13.382c-0.144-0.388 0.053-0.82 0.441-0.965s0.82 0.052 0.965 0.44l4.5 12.085 3.975-6.19-1.471-6.6c-0.09-0.404 0.165-0.805 0.569-0.895 0.054-0.012 0.109-0.018 0.164-0.018 0.351 1e-3 0.655 0.244 0.731 0.587l1.539 6.908c0.044 0.196 7e-3 0.401-0.101 0.569l-4.82 7.509 0.198 3.788 8.475 4.265c0.101 0.052 0.188 0.127 0.255 0.219zm-10.674 12.176c0.515 0 0.932-0.417 0.932-0.932s-0.417-0.933-0.932-0.933-0.932 0.418-0.932 0.933c1e-3 0.514 0.417 0.931 0.932 0.932z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1477)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7396,-1.88e-7,-3.77e-7,1.7396,324,171)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1487)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.443 32.616c-0.414 0-0.75-0.336-0.75-0.75v-24h1.5v24c0 0.414-0.335 0.75-0.75 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.363 32.616c-0.414 0-0.75-0.336-0.75-0.75v-24h1.5v24c0 0.414-0.336 0.75-0.75 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.631 55.036c-0.645 5.603-5.39 9.832-11.03 9.83h-34.306c-5.64 1e-3 -10.384-4.227-11.029-9.83-0.5923-5.128 3.0853-9.766 8.2143-10.358 0.356-0.041 0.714-0.062 1.072-0.062h2.311v-36.75h1.5v29.25h30v-29.25h1.5v36.75h2.481c5.163 0 9.349 4.185 9.349 9.349 0 0.358-0.021 0.716-0.062 1.071zm-39.272-2.232c-0.044 0.275-0.109 0.546-0.193 0.812h22.565c-0.084-0.266-0.148-0.537-0.192-0.812-0.302-2.069 0.318-4.167 1.695-5.74 0.297-0.345 0.625-0.662 0.979-0.948h-27.53c0.355 0.286 0.682 0.603 0.979 0.948 1.379 1.573 1.999 3.67 1.697 5.74zm-3.996-14.188v6h30v-6zm39.84 10.125c-1.49-1.67-3.621-2.625-5.859-2.625h-1.2c-1.475 0.071-2.849 0.772-3.773 1.923-1.091 1.241-1.585 2.898-1.35 4.534 0.059 0.36 0.165 0.711 0.315 1.043l0.069 0.15c0.461 1.102 1.514 1.842 2.706 1.902 1.655 0 2.724-0.989 2.724-2.519 4e-3 -0.494-0.282-0.944-0.73-1.151-0.382-0.163-0.559-0.605-0.395-0.987 0.163-0.381 0.605-0.558 0.987-0.395 0.995 0.448 1.636 1.437 1.637 2.529 0 2.366-1.737 4.019-4.224 4.019-1.479-0.042-2.844-0.808-3.651-2.048h-24.024c-0.807 1.241-2.172 2.006-3.651 2.048-2.488 0-4.225-1.65-4.225-4.019 2e-3 -1.092 0.644-2.082 1.64-2.529 0.381-0.163 0.822 0.013 0.986 0.393 0.163 0.381-0.013 0.822-0.394 0.985-0.448 0.208-0.733 0.657-0.73 1.151 0 1.531 1.069 2.519 2.724 2.519 1.195-0.061 2.249-0.803 2.709-1.907l0.065-0.141c0.15-0.332 0.257-0.683 0.316-1.043 0.234-1.636-0.26-3.293-1.35-4.534-0.925-1.152-2.299-1.852-3.775-1.923h-1.2c-4.334 3e-3 -7.8457 3.519-7.8428 7.853 2e-4 0.299 0.0175 0.598 0.0518 0.895 0.558 4.845 4.659 8.502 9.536 8.502h34.306c4.878 1e-3 8.981-3.656 9.539-8.502 0.256-2.224-0.448-4.451-1.937-6.123z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.693 32.616c-0.414 0-0.75-0.336-0.75-0.75v-24h1.5v24c0 0.414-0.335 0.75-0.75 0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.068 49.866c0-0.828-0.671-1.5-1.5-1.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.829 0 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.068 49.866c0-0.828-0.671-1.5-1.5-1.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.829 0 1.5-0.672 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.068 49.866c0-0.828-0.671-1.5-1.5-1.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.829 0 1.5-0.672 1.5-1.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1509)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.1875,-9.4e-8,-3.77e-7,2.4062,261,59.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1519)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.656 48.548c-1.394-5.578-6.997-9.182-14.272-9.182-6.641 0-12.779 3.958-14.279 9.206-0.113 0.399-0.529 0.629-0.927 0.515-0.399-0.113-0.629-0.529-0.516-0.927 1.705-5.965 8.316-10.294 15.722-10.294 7.987 0 14.161 4.05 15.727 10.318 0.098 0.402-0.149 0.808-0.551 0.906-0.399 0.096-0.801-0.145-0.904-0.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.634 17.616v-2.25h16.5v2.25l-6 2.182v30.944c1.389 1.243 1.508 3.376 0.266 4.766-1.243 1.389-3.377 1.508-4.766 0.265s-1.508-3.376-0.266-4.765c0.084-0.094 0.173-0.182 0.266-0.266v-30.944zm8.25 37.5c1.036 0 1.875-0.839 1.875-1.875s-0.839-1.875-1.875-1.875-1.875 0.839-1.875 1.875 0.839 1.875 1.875 1.875zm0.75-5.16v-30.09h-1.5v30.09c0.493-0.12 1.007-0.12 1.5 0zm-2.55-31.59h3.6l4.085-1.486c4e-3 -1e-3 6e-3 -5e-3 5e-3 -9e-3 -1e-3 -2e-3 -3e-3 -4e-3 -5e-3 -5e-3h-11.766c-8e-3 0-0.01 0.012 0 0.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.134 17.616-6 2.182v30.944c1.389 1.243 1.508 3.376 0.266 4.766-1.243 1.389-3.377 1.508-4.766 0.265s-1.508-3.376-0.266-4.765c0.084-0.094 0.173-0.182 0.266-0.266v-30.944l-6-2.182v-2.25h16.5zm-8.25 37.5c1.036 0 1.875-0.839 1.875-1.875s-0.839-1.875-1.875-1.875-1.875 0.839-1.875 1.875 0.839 1.875 1.875 1.875zm0.75-5.16v-30.09h-1.5v30.09c0.493-0.12 1.007-0.12 1.5 0zm-6.633-33.075 4.083 1.485h3.6l4.084-1.486c4e-3 -1e-3 7e-3 -5e-3 5e-3 -9e-3 0-2e-3 -2e-3 -4e-3 -5e-3 -5e-3h-11.765c-4e-3 1e-3 -7e-3 4e-3 -6e-3 8e-3 0 3e-3 2e-3 5e-3 4e-3 6e-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.111 48.184c0.098 0.402-0.15 0.808-0.552 0.906-0.398 0.096-0.801-0.145-0.903-0.542-1.167-4.666-4.717-7.807-9.772-8.824v-1.522c5.7922 1.057 9.886 4.614 11.227 9.982z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.105 48.572c-0.113 0.399-0.529 0.629-0.927 0.515-0.399-0.113-0.629-0.529-0.516-0.927 1.62-5.124 5.937-8.933 11.222-9.903v1.53c-4.611 0.939-8.352 4.301-9.779 8.785z"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m229.94 187.93c0-1.07-0.87-1.94-1.95-1.94-1.07 0-1.95 0.87-1.95 1.94 0 1.08 0.88 1.95 1.95 1.95 1.08 0 1.95-0.87 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.2 187.2c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.94-0.88 1.94-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.71 185.7c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.94 1.95 1.94 1.07 0 1.94-0.87 1.94-1.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.53 184.25c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95s0.88 1.95 1.95 1.95c1.08 0 1.95-0.87 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.24 184.96c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95 0 1.07 0.88 1.95 1.95 1.95 1.08 0 1.95-0.88 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.02 187c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95s0.88 1.95 1.95 1.95c1.08 0 1.95-0.87 1.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.57 187.06c0-1.08-0.88-1.95-1.95-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.94 1.95 1.94 1.07 0 1.95-0.87 1.95-1.94z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m258.77 193.8c0-1.07-0.87-1.95-1.95-1.95s-1.95 0.88-1.95 1.95c0 1.08 0.87 1.95 1.95 1.95s1.95-0.87 1.95-1.95z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.39 191.7h-0.71c-1.07 0-1.94-0.87-1.94-1.95s0.87-1.95 1.94-1.95h0.71c1.08 0 1.95 0.87 1.95 1.95s-0.87 1.95-1.95 1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1569)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.1458,-1.88e-7,-3.77e-7,2.1458,448.5,179.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.884 13.866v4.453h-4.5v1.811l-1.511 1.51-0.724 20.287 2.235 1.489v1.903h3.009l-0.035 4.5h2.276v2.747l-29.231 12.316-29.269-12.316v-2.749h2.256l0.0352-4.5h2.9588v-1.901l2.235-1.49-0.724-20.287-1.511-1.509v-1.811h-4.4633v-4.453h-3v-6h62.963v6zm-6 5.642v-1.189h-6.75v1.189l1.06 1.061h4.629zm-36.75 25.811h3v-1.903l2.235-1.49-0.724-20.287-1.511-1.509v-1.811h-3v1.811l-1.511 1.51-0.724 20.287 2.235 1.489zm6.724-3.75h2.302l0.697-19.5h-3.696zm2.799 1.5h-3.298l-1.725 1.152v1.098h6.75v-1.098zm-5.023-23.561 1.06 1.061h4.629l1.061-1.061v-1.189h-6.75zm6.739 2.132-0.724 20.287 2.235 1.489v1.903h3v-1.903l2.235-1.49-0.724-20.287-1.511-1.509v-1.811h-3v1.811zm8.235 19.929h2.302l0.697-19.5h-3.696zm2.799 1.5h-3.298l-1.725 1.152v1.098h6.75v-1.098zm-5.023-23.561 1.06 1.061h4.629l1.061-1.061v-1.189h-6.75zm6.739 2.132-0.724 20.287 2.235 1.489v1.903h3v-1.903l2.235-1.49-0.724-20.287-1.511-1.509v-1.811h-3v1.811zm8.235 19.929h2.302l0.697-19.5h-3.696zm4.526 2.652-1.725-1.152h-3.3l-1.725 1.152v1.098h6.75zm-50.25 7.098v0.252l27.769 11.685 27.731-11.685v-0.252zm2.279-4.5-0.023 3h50.968l0.024-3zm2.971-2.598v1.098h6.75v-1.098l-1.725-1.152h-3.3zm2.224-2.652h2.302l0.697-19.5h-3.696zm-2.224-22.061 1.06 1.061h4.629l1.061-1.061v-1.189h-6.75zm-4.4633-2.689h53.963v-2.93h-53.963zm56.963-7.453h-59.962v3h59.962z",
    fill: "#000000"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.ce87e69174e0250139e549f2fb742dbd.svg";
export { ForwardRef as ReactComponent };